import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';
import { Icon, TrustBar, Watermark } from '../ui';
import { FOOTER_COLUMNS, CONTACT } from '../../data/nav';
import { TRUST_ITEMS } from '../../data/home';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="site-footer">
      <div className="container site-footer__trust">
        <TrustBar variant="maroon" items={TRUST_ITEMS.map((i) => ({ ...i, title: t(i.title), desc: t(i.desc) }))} />
      </div>

      <div className="site-footer__body">
        <div className="container site-footer__main">
          <div className="site-footer__brand">
            <Logo />
            <p className="site-footer__blurb">
              {t('Your complete guide to the sacred city of Shri Ram — temples, darshan, stays, seva and everything a pilgrim needs.')}
            </p>
            <ul className="site-footer__contact">
              <li><Icon name="mail" size={16} /><a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></li>
              <li><Icon name="phone" size={16} /><a href={`tel:${CONTACT.phone.replace(/[^+\d]/g, '')}`}>{CONTACT.phone}</a></li>
              <li><Icon name="map-pin" size={16} /><span>{CONTACT.address}</span></li>
            </ul>
            <div className="site-footer__social" aria-label={t('Follow us')}>
              {[['globe', 'Website'], ['message-circle', 'WhatsApp'], ['share-2', 'Share']].map(([icon, label]) => (
                <button key={icon} type="button" className="icon-btn icon-btn--round" aria-label={label}><Icon name={icon} size={16} /></button>
              ))}
            </div>
          </div>

          {FOOTER_COLUMNS.map((col) => (
            <div key={col.title} className="site-footer__col">
              <h3 className="site-footer__title">{t(col.title)}</h3>
              <ul>
                {col.links.map(([label, to]) => (
                  <li key={to}><Link to={to}>{t(label)}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="site-footer__bottom">
          <Watermark variant="temple" />
          <div className="container site-footer__bottom-inner">
            <span>© {new Date().getFullYear()} AyodhyaDham.info · {t('Made with reverence in Ayodhya')}</span>
            <span className="site-footer__legal">
              <Link to="/terms">{t('Terms & Conditions')}</Link>
              <span aria-hidden="true">·</span>
              <Link to="/privacy">{t('Privacy Policy')}</Link>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
